import { useCallback } from 'react';

import { useAppDispatch } from '@/store';

import { useLogoutMutation } from '../api';
import { logout } from '../store';

export function useLogout() {
  const [mutation] = useLogoutMutation();
  const dispatch = useAppDispatch();
  return useCallback(() => {
    const currentPath = window.location.pathname;
    mutation()
      .unwrap()
      .then(() => {
        dispatch(logout());
        localStorage.removeItem('loginTimestamp');
        window.location.href = `/auth/signin?redirectTo=${currentPath}`;
      })
      .catch((error) => {
        console.error('Failed to login:', error);
      });
  }, [mutation, dispatch]);
}
